module.exports = __webpack_public_path__ + "static/media/bg.9db96215.jpg";